import { fromJS } from 'immutable'
import {
  CONSENT_MANAGEMENT_LIST_REQUEST,
  CONSENT_MANAGEMENT_LIST_SUCCESS,
  CONSENT_MANAGEMENT_LIST_FAILURE,
  CONSENT_MANAGEMENT_LIST_RESET,
} from '../../constants'

const init = fromJS({
  isFetching: false,
  isAuthenticated: localStorage.getItem('access_token') !== null,
  redirect: false,
})

export default (state = init, action) => {
  switch (action.type) {
    case CONSENT_MANAGEMENT_LIST_REQUEST:
      return state
        .set('isFetching', true)
    case CONSENT_MANAGEMENT_LIST_SUCCESS:
      if (action.payload.ok) {
        return state
          .set('isFetching', false)
          .set('consent', fromJS(action.payload.consents))
          .set('status', action.payload.ok)
      }
      return state
        .set('isFetching', false)
    case CONSENT_MANAGEMENT_LIST_FAILURE:
      if (action.payload.status === 401) {
        return state
          .set('redirect', true)
      }
      return state
        .set('isFetching', false)
    case CONSENT_MANAGEMENT_LIST_RESET:
      return state
        .set('redirect', false)
        .set('isFetching', false)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/consent-management/consent-management-list-reducer.js